<template>
  <v-container fluid class="pa-2">
<!--    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>-->

    <!-- ACTIONS SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-actions class="justify-end mt-auto">
            <v-btn
                color="success"
                depressed
                class="rounded-lg"
                @click.prevent="updateProfile"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

    </div>

    <!-- PROFILE SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0"><strong>{{ $t('cards.titles.profile') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.profileDetails') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="profileLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!profileLoading">
            <!-- EMAIL -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.email') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">{{ profile.email }}</div>
            </div>
            <!-- FIRSTNAME -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.firstName') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-text-field
                    :disabled="!profile.organizationSettings.nameEditable"
                    v-model="profile.firstName"
                    hide-details
                    dense
                    :placeholder="$t('labels.firstName')"
                ></v-text-field>
              </div>
            </div>
            <!-- LASTNAME -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.lastName') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-text-field
                    :disabled="!profile.organizationSettings.nameEditable"
                    v-model="profile.lastName"
                    hide-details
                    dense
                    :placeholder="$t('labels.lastName')"
                ></v-text-field>
              </div>
            </div>
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.gender') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-autocomplete
                    :disabled="!profile.organizationSettings.genderEditable"
                    v-model="profile.gender"
                    :items="genderMappings"
                    hide-details
                    dense
                ></v-autocomplete>
              </div>
            </div>
            <!-- BIRTHDATE -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.birthDate') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-menu
                    v-if="profile.organizationSettings.birthdayType !== 'YEAR'"
                    ref="menu"
                    :disabled="profile.organizationSettings.birthdayType === 'EMPTY'"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :disabled="profile.organizationSettings.birthdayType === 'EMPTY'"
                        v-model="profile.birthDate"
                        readonly
                        dense
                        hide-details
                        :placeholder="$t('labels.birthDate')"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-if="profile.organizationSettings.birthdayType === 'EXACT'"
                      class="rounded-lg"
                      v-model="profile.birthDate"
                      @input="menu = false"
                      type="date"
                  ></v-date-picker>
                  <v-date-picker
                      v-if="profile.organizationSettings.birthdayType === 'MONTH'"
                      class="rounded-lg"
                      v-model="profile.birthDate"
                      @input="menu = false"
                      type="month"
                  ></v-date-picker>
                </v-menu>
                <v-combobox
                    v-if="profile.organizationSettings.birthdayType === 'YEAR'"
                    v-model="profile.birthDate"
                    :items="years"
                    dense
                    hide-details
                    :placeholder="$t('labels.birthDate')"
                ></v-combobox>
              </div>
            </div>
            <!-- NATIVE LANGUAGE -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.nativeLanguage') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-autocomplete
                    v-model="profile.nativeLanguage"
                    :items="nativeLanguages"
                    :item-text="(language) => { return language.code + ' - ' + language.name }"
                    item-value="code"
                    dense
                    hide-details
                    :placeholder="$t('labels.nativeLanguage')"
                ></v-autocomplete>
              </div>
            </div>
            <!-- COMMUNICATION LANGUAGE -->
<!--            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.communicationLanguage') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">
                <v-autocomplete
                    v-model="profile.communicationLanguage"
                    :items="nativeLanguages.filter((x) => { return communicationLanguages.includes(x.code) })"
                    :item-text="(language) => { return language.code + ' - ' + language.name }"
                    item-value="code"
                    dense
                    hide-details
                    :placeholder="$t('labels.communicationLanguage')"
                ></v-autocomplete>
              </div>
            </div>-->
            <!-- DEPARTMENT -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.department') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">{{ profile.department }}</div>
            </div>
            <!-- LOCATION -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.location') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-8 pa-2">{{ profile.location }}</div>
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <!-- CONNECTIONS SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0"><strong>{{ $t('cards.titles.connections') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.connections') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="profileLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!profileLoading">
            <!-- M2H -->
<!--            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2">
                <div><strong>{{ $t('cards.texts.vimeoTitle') }}</strong></div>
                <div>{{ $t('cards.texts.vimeoDescription') }}</div>
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-6 pa-2">
                {{ profile.vimeoConnected ? $t('cards.texts.vimeoConnected') : $t('cards.texts.vimeoNotConnected') }}
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigate('/connections/watch-on-the-go')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
            </div>-->
            <!-- WEARABLES -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2">
                <div><strong>{{ $t('cards.texts.wearablesTitle') }}</strong></div>
                <div>{{ $t('cards.texts.wearablesDescription') }}</div>
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-6 pa-0">
                <div class="pa-2">
                    {{ profile.wefitterConnected ? $t('cards.texts.wefitterConnected') : $t('cards.texts.wefitterNotConnected') }}
                </div>
<!--                <v-chip
                    class="ma-2 rounded-lg"
                    label
                    outlined
                    color="primary"
                >
                  Fitbit
                </v-chip>
                <v-chip
                    class="ma-2 rounded-lg"
                    label
                    outlined
                    color="primary"
                >
                  Oura
                </v-chip>
                <v-chip
                    class="ma-2 rounded-lg"
                    label
                    outlined
                    color="primary"
                >
                  Garmin
                </v-chip>-->
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigate('/connections/wearables')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
            </div>
            <!-- BIO AGE -->
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2">
                <div><strong>{{ $t('cards.texts.bioAgeTitle') }}</strong></div>
                <div>{{ $t('cards.texts.bioAgeDescription') }}</div>
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-6 pa-0">
                <div class="pa-2">
                  {{ profile.wefitterBioAgeConnected ? $t('cards.texts.wefitterConnected') : $t('cards.texts.wefitterNotConnected') }}
                </div>
                <!--                <v-chip
                                    class="ma-2 rounded-lg"
                                    label
                                    outlined
                                    color="primary"
                                >
                                  Fitbit
                                </v-chip>
                                <v-chip
                                    class="ma-2 rounded-lg"
                                    label
                                    outlined
                                    color="primary"
                                >
                                  Oura
                                </v-chip>
                                <v-chip
                                    class="ma-2 rounded-lg"
                                    label
                                    outlined
                                    color="primary"
                                >
                                  Garmin
                                </v-chip>-->
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigate('/connections/bio-age')"
                  >
                    {{ $t('buttons.manage') }}
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <!-- CONSENTS SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0"><strong>{{ $t('cards.titles.consents') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.consents') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text class="d-flex flex-wrap ma-0 pa-2">
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-3 pa-2"><strong>{{ $t('labels.date') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-6 pa-2"><strong>{{ $t('labels.name') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-1 pa-2 d-flex justify-end"><strong>{{ $t('labels.actions') }}</strong></div>
            </div>

            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 pa-2"><v-divider></v-divider></div>
            </div>

            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch" v-if="consent">
              <div class="col-3 pa-2">
                <div><strong>{{ $moment(consent.lastUpdated).format('MM/DD/YYYY HH:mm') }}</strong></div>
<!--                <div class="text-caption">Status: accepted</div>-->
              </div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-6 pa-2"><strong>{{ $t('cards.texts.tosAndPrivacy') }}</strong></div>
              <div class="col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-1 py-2 px-0 d-flex justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      small
                      @click.prevent="navigate('/consent')"
                  >
                    <v-icon small>fal fa-eye</v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <!-- ACTIONS SECTION -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-actions class="justify-end mt-auto">
            <v-btn
                color="success"
                depressed
                class="rounded-lg"
                @click.prevent="updateProfile"
            >
              {{ $t('buttons.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

    </div>

    <!-- VIMEO DIALOG -->
    <v-dialog
        v-model="showVimeoDialog"
        max-width="600"
        scrollable
        persistent
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-card-title><strong>{{ $t('cards.titles.connectWithVimeo') }}</strong></v-card-title>
        <v-card-text>
          <div>{{ vimeoPassword }}</div>
        </v-card-text>
        <v-card-actions class="justify-end mt-auto">
          <v-btn
              color="primary"
              depressed
              class="rounded-lg"
              @click.prevent="showVimeoDialog = false"
          >
            {{ $t('buttons.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            icon
            @click="snack = false"
        >
          <v-icon>fal fa-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
  </v-container>

</template>

<script>
import api from "@/api/api";
import languageCodes from "@/utils/language-codes.json";
import years from "@/utils/years.json";

export default {
  name: "m2h-profile",
  props: [],
  components: {
  },
  data() {
    return {
      isLoading: false,
      profile: {
        birthDate: "",
        email: "",
        firstName: "",
        lastName: "",
        organizationSettings: {
          
        }
      },
      form: {
        email: ''
      },
      menu: false,
      snack: false,
      snackColor: '',
      snackText: '',
      communicationLanguage: {},
      nativeLanguage: {},
      nativeLanguages: [],
      communicationLanguages: [
          'nl',
          'en'
      ],
      consent: {},
      currentYear: '',
      years: [],
      showVimeoDialog: false,
      vimeoPassword: '',
      profileLoading: false
    }
  },
  mounted() {
    this.fetchProfile()
    this.fetchConsent()
    this.nativeLanguages = languageCodes;
    this.years = years
    this.currentYear = new Date().getFullYear()
  },
  computed: {
    genderMappings() {
      return [
        { value: 'F', text: this.$t('forms.gender.female') },
        { value: 'M', text: this.$t('forms.gender.male') },
        { value: 'X', text: this.$t('forms.gender.nonBinary') },
        { value: 'U', text: this.$t('forms.gender.unknown') }
      ]
    }
  },
  methods: {
    async fetchProfile() {
      const that = this
      that.profileLoading = true
      await api.account.getProfile()
          .then((res) => {
            that.profile = res.data
            that.profileLoading = false
          })
    },
    async updateProfile () {
      const that = this
      await api.account.updateProfile(that.profile)
          .then(() => {
            that.snack = true
            that.snackColor = 'success'
            that.snackText = this.$t('axios.success.profileUpdated')
          })
    },
    
    async fetchConsent(){
      let consent = await api.consent.get().then((res) => { return res.data })
      if (consent){
        this.consent = consent
      }
    },
    
    async connectVimeo(){
      let vimeoPassword = await api.account.connectVimeo().then((res) => { return res.data })
      if (vimeoPassword){
        this.vimeoPassword = vimeoPassword
        this.showVimeoDialog = true
        this.profile.vimeoConnected = true
      }
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>